var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#191B32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6969 16.4736L9.34875 21.9786C9.31166 21.996 9.2708 22.0038 9.22989 22.0013C9.18899 21.9989 9.14937 21.9862 9.11465 21.9644C9.07994 21.9426 9.05125 21.9125 9.03122 21.8767C9.01119 21.841 9.00045 21.8008 9 21.7598V18.2189C9 18.1606 9.02032 18.1042 9.05746 18.0594C9.0946 18.0146 9.14623 17.9841 9.20344 17.9732L16.9416 16.5045C17.4841 16.4017 17.4841 15.6248 16.9416 15.522L9.20312 14.0532C9.14603 14.0423 9.09451 14.0119 9.05744 13.9671C9.02037 13.9223 9.00006 13.8661 9 13.8079V10.2686C9 10.0892 9.18375 9.94793 9.34875 10.0186L22.6969 15.5551C22.7866 15.5938 22.863 15.6579 22.9168 15.7395C22.9705 15.8211 22.9991 15.9166 22.9991 16.0143C22.9991 16.112 22.9705 16.2076 22.9168 16.2892C22.863 16.3708 22.7866 16.4349 22.6969 16.4736Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.f7d37897ebc47891446bd03744724a42.svg";
export { ForwardRef as ReactComponent };